<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <van-nav-bar
        title="检验报告"
        left-arrow
        left-text="返回"
        :fixed="true"
        @click-left="onClickLeft"
      />
    </div>
    <div class="head">
      <div class="title_head">
        <div class="title_head_name">{{ name }}</div>
        <div class="title_head_age">
          <span class="geary">年龄：</span>{{ age }}{{ ageUnit }}
        </div>
      </div>
    </div>
    <div class="body">
      <div
        class="listcard"
        v-if="emptyflag"
        v-for="(item, index) in lissampleList"
        :key="index"
        @click="reportDetialClick(item)"
      >
        <div class="listcard_title line">
          <div class="listcard_title_a">状态</div>
          <div class="listcard_title_b color1">可查看</div>
        </div>
        <div class="listcard_row">
          <div class="listcard_row_a">日期：</div>
          <div class="listcard_row_b">{{ item.outReportDate }}</div>
        </div>
      </div>
      <div v-if="!emptyflag">
        <van-empty
          image="https://account.kmmds.top/datainfo_pic/error.png"
          description="暂无报告单"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import setOptions from "@/mixins/setOption";
export default {
  mixins: [setOptions],
  data() {
    return {
      lissampleList: [],
      price: null,
      clientId: "",
      name: "",
      age: "",
      ageUnit: "岁",
      patientSeq: "暂无",
      emptyflag: true,
      CardNo: "",
    };
  },
  components: {
    Nav,
  },
  created() {
    this.clientId = this.$route.query.clientId;
    this.name = this.$route.query.name;
    this.CardNo = this.$route.query.CardNo;
    this.age = this.$route.query.age;
    this.getlissample();
  },
  methods: {
    onClickLeft() {
      this.$router.push({
        path: "/reportList_D",
        query: {
          clientId: this.clientId,
          name: this.name,
          CardNo: this.CardNo,
          age: this.age,
        },
      });
    },
    async getlissample() {
      // console.log(this.method_depy_type)
      try {
        //"2020006088"
        let reqData = {
          PatientID: this.clientId,
          CardNo: this.CardNo,
        };
        this.$showLoad();
        let url = "/report/QueryLaboratoryRecordList";
        // console.log(R_data)
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          reqData,
          (data) => {
            
            this.$hideLoad();
            if (Object.keys(data.data.data.List.Item).length == 0) {
              this.emptyflag = false;
            } else {
              this.lissampleList = data.data.data.List.Item;
            }

          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    reportDetialClick(item) {
      // console.log(item);
      this.$router.push({
        path: "/examineReportDetail",
        query: {
          inReportID: item.outReportID,
          inReportClass: item.outReportClass,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.color1 {
  color: #2ed573 !important;
}
.color2 {
  color: #ff4400 !important;
}
.main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  background-color: #eee;
  .nav {
    height: 6vh;
    .top {
      height: 6vh;
    }
  }
  .head {
    width: 100%;
    background-color: #5b8df6;
    height: 15vh;
    display: flex;
    flex-direction: column;
    color: white;
    padding: 15px;
    .title_head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 6vh;
      .title_head_name {
        font-size: 25px;
      }
      .title_head_age {
        font-size: 14px;
      }
    }
    .head_row {
      font-size: 14px;
      line-height: 4vh;
      color: #ffffff;
    }
  }
  .body {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 94vh;
    overflow: scroll;
    .listcard {
      display: flex;
      flex-direction: column;
      background-color: white;
      width: 100%;
      margin: 0px auto;
      margin-bottom: 8px;
    }
    .listcard_title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 24px;
      width: 95%;

      padding: 10px;
      margin: 0px auto;
      .listcard_title_a {
        font-size: 16px;
      }
      .listcard_title_b {
        font-size: 14px;
        color: #999;
      }
    }
    .listcard_row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 15px;
      width: 95%;

      padding: 10px;
      margin: 0px auto;
      .listcard_row_a {
        font-size: 14px;
        color: #999;
      }
      .listcard_row_b {
        font-size: 14px;
      }
    }
    .listcard_money {
      line-height: 35px;
      font-size: 14px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      width: 95%;
      text-align: end;
      .moneycolor {
        color: #5b8df6;
        font-weight: bolder;
        font-size: 18px;
      }
    }
  }
}
</style>
